import { createCheckoutSession } from './backendService';
import { stripePromise } from '../config/stripe';

// Create and redirect to Stripe Checkout
export const createStripeCheckout = async (paymentData) => {
  try {
    const stripe = await stripePromise;
    if (!stripe) {
      const isHttps = typeof window !== 'undefined' && window.location?.protocol === 'https:';
      const hostname = typeof window !== 'undefined' ? window.location?.hostname : '';
      throw new Error(
        `Stripe failed to load. ${
          isHttps
            ? 'Ensure a LIVE publishable key is configured for this host.'
            : 'Use a TEST key in development or serve over HTTPS for live keys.'
        } (host: ${hostname}).`
      );
    }

    // Create checkout session via backend
      const checkoutSession = await createCheckoutSession({
      amount: paymentData.amount,
      currency: 'usd',
      quoteId: paymentData.quoteId,
      services: paymentData.services,
      campaignType: paymentData.campaignType,
      customerEmail: paymentData.customerEmail,
      customerName: paymentData.customerName,
      description: paymentData.description,
        successUrl: `${window.location.origin}/payment-success?session_id={CHECKOUT_SESSION_ID}&client_reference_id=${encodeURIComponent(
          paymentData.quoteId
        )}`,
      cancelUrl: `${window.location.origin}/?payment=cancelled`
    });

    if (!checkoutSession.success) {
      throw new Error('Failed to create checkout session');
    }

    // If backend returned a direct URL (dev/mock or payment link), navigate to it
    if (checkoutSession.url) {
      window.location.assign(checkoutSession.url);
      return { success: true, sessionId: checkoutSession.id };
    }

    // Redirect to Stripe Checkout (real session)
    const { error } = await stripe.redirectToCheckout({ sessionId: checkoutSession.id });

    if (error) {
      throw error;
    }

    return { success: true, sessionId: checkoutSession.id };
    
  } catch (error) {
    console.error('Stripe checkout error:', error);
    throw error;
  }
};

// Alternative: Create payment link using Stripe API
export const createStripePaymentLink = async (paymentData) => {
  try {
    // In production, this would be a real API call to your backend
    // which would use the Stripe API to create a payment link
    
    // For demo purposes, we'll create a dynamic payment link URL
    const baseUrl = 'https://buy.stripe.com/test_';
    const amount = paymentData.amount;
    const successUrl = `${window.location.origin}/payment-success`;
    const cancelUrl = `${window.location.origin}/?payment=cancelled`;
    
    // Create a more dynamic payment link
    const paymentLinkUrl = `${baseUrl}${amount}?prefilled_email=${encodeURIComponent(paymentData.customerEmail)}&client_reference_id=${paymentData.quoteId}&success_url=${encodeURIComponent(successUrl)}&cancel_url=${encodeURIComponent(cancelUrl)}`;
    
    return { success: true, paymentLinkUrl };
    
  } catch (error) {
    console.error('Stripe payment link error:', error);
    throw error;
  }
};

// Get Stripe instance
export const getStripe = () => stripePromise;

export default {
  createStripeCheckout,
  createStripePaymentLink,
  getStripe
};
